import React, { useEffect, useRef } from "react";

import Text from "src/components/text";
import SeekComponent from "./components/seek";

import { fetchMicroLearnings } from "src/redux/actions/coaching/microLearning";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import { MicroLearning } from "src/types/coaching/microLearning";

import InfiniteScroll from "src/components/infiniteScroll";
import TimeAgo from "react-timeago";

import _ from "lodash";
import cx from "classnames";
import styles from "./microLearning.module.scss";
import seekStyles from "./components/seek/seek.module.scss";
import PromptSuggestions from "./components/promptSuggestions";
import Truncate from "src/components/truncate";
import Tooltip from "src/components/tooltip";

const MicroLearningPage: React.FC<object> = () => {
const dispatch = useDispatch();
const [query, setQuery] = React.useState<string>("");
const editorRef = useRef<HTMLDivElement>(null);

function getEditorText(editor: HTMLDivElement): string {
  let result = "";

  editor.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      result += node.textContent;
    }
    else if (
      node instanceof HTMLElement &&
      node.dataset?.value
    ) {
      result += node.dataset.value;
    }
    else if (
      node instanceof HTMLElement &&
      node.classList.contains(seekStyles.slot)
    ) {
      const text = node.textContent?.trim() || "";
      const placeholder = node.getAttribute("data-placeholder") || "";

      result += text === placeholder ? "" : text;
    }
    else if (node instanceof HTMLBRElement) {
      result += " ";
    }
  });

  return result.trim();
}

  const PODCAST_TYPES = [{
    label: "narrative",
    icon: "paperflite-list-layout",
  },
  {
    label: "monologue",
    icon: "paperflite-mic",
  },
  {
    label: "conversational",
    icon: "paperflite-engage",
  },
];

  const DURATIONS = [
    "5 min",
    "10 min",
    "15 min",
    "20 min",
    "25 min",
    "30 min",
  ];

function slot(placeholder: string) {
  const input = document.createElement("span");

  input.contentEditable = "true";
  input.className = seekStyles.slot;

  input.setAttribute("data-placeholder", placeholder);

  input.addEventListener("input", () => {
    const newQuery = getEditorText(editorRef.current!);
    setQuery(newQuery);
  });

  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  });

  return input;
}

function selectorSlot(options: { label: string; icon: string }[]) 
{
  let selectedIndex = 0;

  const wrapper = document.createElement("span");
  wrapper.contentEditable = "false"
  const left = document.createElement("button");
  const value = document.createElement("span");
  const right = document.createElement("button");
  wrapper.className = seekStyles.selectorSlot;
  left.className = cx(seekStyles.selectorButton, seekStyles.left);
  right.className = cx(seekStyles.selectorButton, seekStyles.right);
  value.className = seekStyles.selectorValue;

  left.innerHTML = '<i class="paperflite-dropdown"></i>';
  right.innerHTML = '<i class="paperflite-dropdown"></i>';

  const icon = document.createElement("i");
  icon.className = options[selectedIndex].icon;

  const text = document.createElement("span");
  text.textContent = options[selectedIndex].label;

  value.append(icon, text);

  wrapper.dataset.value = options[selectedIndex].label;

  const update = () => {
    value.innerHTML = "";
    const icon = document.createElement("i");
    icon.className = options[selectedIndex].icon;
    const text = document.createElement("span");
    text.textContent = options[selectedIndex].label;
    value.append(icon, text);
    wrapper.dataset.value = options[selectedIndex].label;

    if (editorRef.current) {
      setQuery(getEditorText(editorRef.current));
    }
  };

 left.onclick = (e) => {
  e.preventDefault();

  selectedIndex =
    (selectedIndex - 1 + options.length) % options.length;

  update();
};

right.onclick = (e) => {
  e.preventDefault();

  selectedIndex =
    (selectedIndex + 1) % options.length;

  update();
};

  wrapper.append(left, value, right);

  return wrapper;
}

function durationSelectorSlot(options: string[]) {
  let selectedIndex = 0;

  const wrapper = document.createElement("span");
  wrapper.contentEditable = "false";

  const left = document.createElement("button");
  const value = document.createElement("span");
  const right = document.createElement("button");

  wrapper.className = seekStyles.selectorSlot;
  left.className = cx(seekStyles.selectorButton, seekStyles.left);
  right.className = cx(seekStyles.selectorButton, seekStyles.right);
  value.className = seekStyles.selectorValue;

  left.innerHTML = '<i class="paperflite-dropdown"></i>';
  right.innerHTML = '<i class="paperflite-dropdown"></i>';

  value.textContent = options[selectedIndex];

  wrapper.dataset.value = options[selectedIndex];

  const update = () => {
    value.textContent = options[selectedIndex];
    wrapper.dataset.value = options[selectedIndex];

    if (editorRef.current) {
      setQuery(getEditorText(editorRef.current));
    }
  };

 left.onclick = (e) => {
  e.preventDefault();

  selectedIndex =
    (selectedIndex - 1 + options.length) % options.length;

  update();
};

right.onclick = (e) => {
  e.preventDefault();

  selectedIndex =
    (selectedIndex + 1) % options.length;

  update();
};
  wrapper.append(left, value, right);

  return wrapper;
}
const [showAssetHint, setShowAssetHint] = React.useState(false);
function insertTemplate(type: string) {
  const editor = editorRef.current;
  if (!editor) return;
  editor.innerHTML = "";

  if (type === "podcast") {
     setShowAssetHint(true);
    editor.appendChild(text("Create a "));
    editor.appendChild(selectorSlot(PODCAST_TYPES));
    editor.appendChild(text(" type podcast based on the attached content, focusing on "));
    editor.appendChild(slot("topic of interest"));
    editor.appendChild(text(" for a "));
    editor.appendChild(durationSelectorSlot(DURATIONS));
    editor.appendChild(text(" listen"));
    
  }

  if (type === "article") {
     setShowAssetHint(true);
    editor.appendChild(text("Create a learning article from the attached content focusing on "));
    editor.appendChild(slot("topic of interest"));
  }

  editor.querySelectorAll("input")[0]?.focus();
  setQuery(getEditorText(editor));
}

function text(content: string) {
  return document.createTextNode(content);
}

  const { loading, loaded, learnings, hasMoreItems, nextPage, currentPage } =
    useSelector((state: any) => {
      const microLearningState = _.get(state.coaching, `microLearnings`);
      const loading = _.get(microLearningState, "loading");
      const learnings = _.get(microLearningState, "items");
      const loaded = _.get(microLearningState, "loaded", false);

      const pagination = _.get(microLearningState, "pagination");
      const totalRecordsCount = _.get(pagination, "totalRecordsCount", 0);
      const currentPage = _.get(pagination, "currentPage", 0);
      const total = _.get(pagination, "totalPages", 0);
      const hasMoreItems = _.get(pagination, "hasMoreItems");

      let nextPage: number | null = _.get(pagination, "currentPage", 0) + 1;
      if (nextPage && nextPage >= total) {
        nextPage = null;
      }

      return {
        loading,
        loaded,
        learnings,
        totalRecordsCount,
        currentPage,
        total,
        nextPage,
        hasMoreItems,
      };
    }, _.isEqual);

  const handleLoadMore = () => {
    if (nextPage) {
      dispatch(
        fetchMicroLearnings({
          page: nextPage,
          limit: 10,
        }),
      );
    }
  };

  useEffect(() => {
    if (_.size(learnings) > 0) {
      return;
    }

    dispatch(
      fetchMicroLearnings({
        page: 0,
        limit: 10,
      }),
    );
  }, []);

  return (
    <section className={styles.container}>
      <div className={styles.top}>
        <SeekComponent
          editorRef={editorRef}
          query={query}
          onQueryChange={setQuery}
          getEditorText={getEditorText}
        />
        <PromptSuggestions onSelect={insertTemplate} />
      </div>
      <div className={styles.bottom}>
        <div className={styles.wrap}>
          <InfiniteScroll
            className={styles.list}
            loading={loading}
            hasMore={hasMoreItems}
            loadMore={handleLoadMore}
            loader={() => {
              return _.times(
                _.size(learnings) === 0 || currentPage === 0 ? 7 : 1,
                (index) => <MicroLearningPlaceholder key={index} />,
              );
            }}
          >
            <div className={styles.learningContainer}>
              {(learnings || []).map((item: MicroLearning, index: number) => {
                return (
                  <MicroLearningItem
                    key={item.id}
                    microLearning={item}
                    index={index}
                  />
                );
              })}
            </div>
          </InfiniteScroll>
        </div>
      </div>

      <div className={styles.emptyMessageContainer}>
        {_.size(learnings) === 0 && !loading && (
          <div className={styles.emptyMessage}>
            <div className={styles.content}>
              <span className={styles.title}>
               Get Started with Microlearning
              </span>
              <span className={styles.description}>
                Turn your content into quick, personalized learning experiences. Create articles for knowledge building and podcasts for learning on the move.
              </span>
            </div>
            <img
              className={styles.emptyImage}
              src="/images/microlearning_default.png"
              alt=""
            />
          </div>
        )}
      </div>
    </section>
  );
};

const MicroLearningItem = ({ microLearning, index }) => {
  const navigate = useNavigate();

  const modifiedDate = _.get(microLearning, "modifiedDate", null);

  const handleClick = (item: MicroLearning) => {
    navigate(`/coaching/microlearning/${item.id}`);
  };

  const podcastType = "discovery";
  const rotation = `rotate-${index % 5}`;

  const modalities = _.get(microLearning, "modalities", []);

  return (
    <div
      key={microLearning.id}
      className={styles.wrapper}
      onClick={() => handleClick(microLearning)}
    >
      <div className={styles.metadata}>
        <div className={styles.pill}>
          {modifiedDate > 0 ? (
            <TimeAgo date={parseInt(modifiedDate)} />
          ) : (
            "few seconds ago" 
          )}
        </div>
        {modalities.filter((modality) => modality === 'article' || modality === 'podcast').map((modality) => (
          <div className={styles.pill}>{modality}</div>
        ))}
      </div>
      <div key={microLearning.id} className={styles.item}>
        <div className={styles.left}>
            <Text
              lines={1}
              className={styles.name}
              text={microLearning.title}
              tooltip={microLearning.title}
            />
            <Text
              lines={2}
              className={styles.description}
              text={microLearning.description}
            />
        </div>
        {/* <div className={cx(styles.right, styles[rotation])}>
          <img
            src="/images/assets/courseThumbnail.jpg"
            alt={microLearning.title}
            className={styles.course}
          />
          <div className={styles.thumbnails}>
            <img
              src="/images/assets/podcastThumbnail.jpg"
              alt={microLearning.title}
              className={styles.podcast}
            />
            <img
              src="/images/assets/simulationThumbnail.jpg"
              alt={microLearning.title}
              className={cx(
                styles.simulation,
                podcastType === "discovery"
                  ? styles.discovery
                  : styles.coldcall,
              )}
            />
          </div>
        </div> */}
      </div>
      <div className={styles.divider}></div>
    </div>
  );
};

const MicroLearningPlaceholder = () => {
  return (
    <div
      className={cx(styles.learningPlaceholderContainer, styles.placeholder)}
    >
      {_.times(3, (index) => (
        <div key={index} className={cx(styles.placeholderwrapper)}>
          <div className={styles.metadata}>
            <div className={cx(styles.block, styles.pill)} />
            <div className={cx(styles.block, styles.pill)} />
          </div>

          <div className={styles.container}>
            <div className={styles.left}>
              <div className={cx(styles.block, styles.title)} />
              <div className={cx(styles.block, styles.line)} />
              <div className={cx(styles.block, styles.lineShort)} />
            </div>
          </div>

          <div className={styles.divider} />
        </div>
      ))}
    </div>
  );
};

export default MicroLearningPage;
